import { publicApiClient } from '@api/client';
import type {
  AcceptInviteRequest,
  AcceptInviteResponse,
  ValidateInviteResponse,
} from '@schemas/invites';

export const validateInviteToken = async (token: string): Promise<ValidateInviteResponse> => {
  const { data } = await publicApiClient.get<ValidateInviteResponse>(
    '/public/invite/validate-token',
    { params: { token } },
  );
  return data;
};

export const acceptInvite = async (body: AcceptInviteRequest): Promise<AcceptInviteResponse> => {
  const { data } = await publicApiClient.post<AcceptInviteResponse>(
    '/public/invite/accept',
    body,
  );
  return data;
};
